export default [function() {
  this.isVisible = true;
  this.onClose = this.onClose || angular.noop;

  this.close = () => {
    this.isVisible = false;
    this.onClose();
  };
}];
